// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-rewritten-packages_a11y-announcer_59cd58ed_node_modules_a11y-announcer_templates_comp-89eb0a"], function() { return __webpack_require__("./assets/garaje.js"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
